import { TextField, styled } from '@mui/material';

const InvisibleTextField = styled(TextField)`
  & input {
    width: 0;
    height: 0;
    padding: 0;
  }
`;

export default InvisibleTextField;
